<template>
    <div
        class="editor"
        :class="[
            {
                'editor--no-sidebar':
                    !isConfiguratorActive &&
                    !isListeditorActive &&
                    !isFileeditorActive &&
                    !isFilemanagerActive &&
                    !isTextpickerActive,
                'editor--configurator': isConfiguratorActive,
                'editor--listeditor': isListeditorActive,
                'editor--filemanager': isFilemanagerActive,
                'editor--fileeditor': isFileeditorActive,
                'editor--settings': isSettingsActive,
                'editor--textpicker': isTextpickerActive,
                'editor--modulecreator': isModulecreatorActive,
                'editor--configurator-modules': getActiveConfiguratorGroup === 'modules',
                'editor--configurator-header':
                    getActiveConfiguratorGroup === 'menus' && getActiveMenuType === 'header',
                'editor--configurator-footer':
                    getActiveConfiguratorGroup === 'menus' && getActiveMenuType === 'footer'
            },
            getCurrentDeviceClass
        ]"
    >
        <app-header></app-header>
        <app-page v-bind:editor-mode="true"></app-page>
        <app-configurator v-if="isConfiguratorActive"></app-configurator>
        <app-listeditor v-if="isListeditorActive"></app-listeditor>
        <app-filemanager v-if="isFilemanagerActive"></app-filemanager>
        <app-fileeditor v-if="isFileeditorActive"></app-fileeditor>
        <app-settings v-if="isSettingsActive"></app-settings>
        <app-textpicker v-if="isTextpickerActive"></app-textpicker>
        <app-modulecreator v-if="isModulecreatorActive"></app-modulecreator>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/assorted/Header.vue';
import Configurator from '@/components/assorted/Configurator.vue';
import Listeditor from '@/components/assorted/Listeditor.vue';
import Page from '@/components/assorted/Page.vue';
import Filemanager from '@/components/assorted/Filemanager.vue';
import Fileeditor from '@/components/assorted/Fileeditor.vue';
import Settings from '@/components/assorted/Settings.vue';
import Textpicker from '@/components/assorted/Textpicker.vue';
import Modulecreator from '@/components/assorted/Modulecreator.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-header': Header,
        'app-configurator': Configurator,
        'app-listeditor': Listeditor,
        'app-page': Page,
        'app-filemanager': Filemanager,
        'app-fileeditor': Fileeditor,
        'app-settings': Settings,
        'app-textpicker': Textpicker,
        'app-modulecreator': Modulecreator
    },
    methods: {},
    computed: {
        ...mapGetters([
            'isConfiguratorActive',
            'isListeditorActive',
            'isFilemanagerActive',
            'isFileeditorActive',
            'isSettingsActive',
            'isTextpickerActive',
            'isModulecreatorActive',
            'getCurrentDeviceClass',
            'getActiveConfiguratorGroup',
            'getActiveMenuType'
        ])
    },
    created() {},
    mounted() {
        // automatically bind links inside user generated content to vue router
        window.addEventListener('click', (event) => {
            if (
                !event.target ||
                !event.target.href ||
                !event.target.matches(".module_cms a:not([href*='://'])")
            ) {
                return;
            }
            let target = event.target.getAttribute('target');
            if (target && /\b_blank\b/i.test(target)) {
                return;
            }
            event.preventDefault();
            this.$router.push(new URL(event.target.href).pathname);
        });
    }
};
</script>
